module.exports = __webpack_public_path__ + "img/small-6.fe3e1447.jpg";